import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CondicionesComponent} from '../condiciones.component'
//Services
import {ConditionService} from 'src/app/core/services/parameters/condition.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarCondicionModal implements OnInit {

  editConditionForm: FormGroup;
  loading = false;
  showAlert = false;
  conditionId;
  conditionData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<CondicionesComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private conditionService: ConditionService
  ) {
  }

  ngOnInit(): void {
    this.editConditionForm = this.fb.group({
      condition: [, Validators.required]
    })
    this.conditionId = this.data.id;
    this.conditionService.getConditionById(this.conditionId).subscribe(_res => {
      this.conditionData = _res;
      this.editConditionForm.patchValue({
        condition: _res.name
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editConditionForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editConditionForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.condition
      }
      this.conditionService.updateCondition(this.conditionId, data).subscribe(_res => {
        this.alert.setNotice('Condición actualizada correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
            setTimeout(() => this.onNoClick(true), 1000);
        }, _err => {
            this.alert.setNotice('No se pudo actualizar la condición', 'danger');
            this.showAlert = true;
            this.loading = false;
        })
      } else {
        this.loading = false;
      }
    }

}
